import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as R from 'ramda';
import * as _ from 'lodash';
import moment from 'moment';
import Select from 'react-select-nested-group';
import { subDays } from 'date-fns';
import { DateRangePicker } from 'react-date-range';
import { Popover, PopoverBody } from 'reactstrap';

import Users from '../../ducks/Users';
import Things from '../../ducks/Things';

import { Spinner } from '../common/Spinner/index';


import './index.css';
import calenderIcon from '../../assets/img/calender.png';
import Modal from 'react-bootstrap4-modal';

const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center',
};

const groupedOptions = [
  {
    options: [
    { value: 'All', label:'ALL'},
    { value: 'LOW_TEMPERATURE_DETECTED', label: 'LOW TEMPERATURE DETECTED' },
    { value: 'LOW_HUMIDITY_DETECTED', label: 'LOW HUMIDITY DETECTED' },
    { value: 'HIGH_TEMPERATURE_DETECTED', label: 'HIGH TEMPERATURE DETECTED' },
    { value: 'HIGH_HUMIDITY_DETECTED', label: 'HIGH HUMIDITY DETECTED' }
    ]
  }
];

const formatGroupLabel = data => (
  <div style={groupStyles}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>

  </div>
);

class TemperatureReport extends Component {

  constructor() {
    super();
    this.state = {
      user: {},
      popoverOpen: false,
      report:false,
      loading: true,
      selectedGroups:[],
      userGroups:[],
      vehicleNumberPlate: [],
      things: [],
      notifications: [],
      maxDateRange : new Date(),
      dateRangePicker: {
        selection: {
          startDate: subDays(new Date(), 2),
          endDate: new Date(),
          key: 'selection',
        },
      },
      collapse: [],
      showModal: false,
      lat: 0,
      lng: 0,
      skip:0
    }

  }

  async componentDidMount() {

    let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
    let userData = JSON.parse(localStorage.getItem("user"));
    let userGroups = userData['user']['group'];
    if (userGroups['child']){
      let groups = userGroups['child'];
      const mappedGroups = R.map(group => ({ value: group._id, label: `${group.name || 'N/A'}` }))(groups);
      await this.setState({ ...this.state, userGroups: mappedGroups });
    }
    await this.props.thingsActions.getGroupVehicles({ groupId:  companyInfo.groupId });
  }

  handleGroupChange = async (selectedOption) => {
    await this.setState({ ...this.state, selectedGroups: selectedOption });
  };

  searchVehicle = async (selectedOption) => {
    await this.setState({ ...this.state, things: selectedOption,skip:0 });
  };

  toggle = () => {
    this.setState({ ...this.state, popoverOpen: !this.state.popoverOpen });
  };

  async handleRangeChange(which, payload) {
    let endDate = moment(payload.selection.startDate).add(1, "month");
    let currentDayDate = new Date();
    if (endDate <currentDayDate){
      await this.setState({
        [which]: { ...this.state[which], ...payload, },
        maxDateRange : endDate['_d']
      });
    } else {
      await this.setState({
        [which]: { ...this.state[which], ...payload, },
        maxDateRange : currentDayDate
      });
    }
  };
  async generateExcell(){
      let obj = this.state.dateRangePicker.selection ;

      let vehicels = [];
      let groups = [];

      let body =   {
        startDate :  moment(this.state.dateRangePicker.selection.startDate),
        endDate :  moment(this.state.dateRangePicker.selection.endDate),
        skip : this.state.skip
      };
      if (this.state.things) {
        vehicels = _.map(this.state.things, (item) => item.value);
        if (vehicels.indexOf("All") != -1 ){
          vehicels = _.map(this.props.things, (item) => item._id);
        }
        obj.things = vehicels;
        body.thing = vehicels;
      };
      if (this.state.selectedGroups){
        groups = _.map(this.state.selectedGroups, (item) => item.value);
        obj.groups = groups;
        body.groups = groups;
      } else {
        delete  obj.groups;
      }
  
      await this.props.actions.generateTemperatureReport(obj);
      this.setState({ ...this.state, 'report':true });
  }

  navigateToLogs = () => {
    this.props.history.push("/download/reports");
  };

  toggleModel = () => {
          this.setState({ ...this.state, 'report':false });
  };
  

  render() {

    const loader = <Spinner key='1' />;

    let options= [{value : 'All', label : 'ALL'}]
    
    this.props.things && this.props.things.map(item => {
      if (item.type === "vehicle"){
        options.push({ value: item._id,label: item.name})
      }
    });

    return(

        <>
              <Modal
          visible={this.state.report}
          dialogClassName="delete-modal-dialog"
        >
          <div>
            <button
              type="button"
              className="close close-x"
              aria-label="Close"
              onClick={() => this.toggleModel()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-heading">
            <h5 className="car-and-device-assig">Report Request</h5>
          </div>
          <div className="modal-body">
            <h6>Your report is being generated. Please check log section.</h6>
          </div>
          <div className="modal-footer model-btn">
            <button
              className="btn auxo-primary-btn"
              onClick={() => this.navigateToLogs()}
            >
              View Reports
            </button>{" "}
            <button
              className="btn auxo-primary-btn"
              onClick={() => this.toggleModel()}
            >
              Cancel
            </button>
          </div>
        </Modal>
            <div className='row'>
                <div className='col-lg-3 col-md-3 col-sm-3'>
                    <div className='form-group'>
                        <Select
                        name='form-field-name'
                        value={this.state.selectedGroups}
                        isClearable={true}
                        isSearchable={true}
                        placeholder='Search Groups'
                        onChange={this.handleGroupChange}
                        isMulti
                        options={this.state.userGroups}
                        />
                    </div>
                </div>

                <div className='col-lg-3 col-md-3 col-sm-3'>
                    <div className='form-group'>
                        <Select
                        name='form-field-name'
                        value={this.state.things}
                        isClearable={true}
                        isSearchable={true}
                        placeholder='Search Devices'
                        onChange={this.searchVehicle}
                        isMulti
                        options={options}
                        />
                    </div>
                </div>

                <div className='col-lg-2 col-md-2 col-sm-2'>
                <div className='selected-trip-Interval '>

                    <p className='margin-zero'>
                    <b>From:</b> {moment(this.state.dateRangePicker.selection.startDate).format('MMMM DD YYYY')}
                    </p>
                    <p className='margin-zero'>
                    <b>To:</b> {moment(this.state.dateRangePicker.selection.endDate).format('MMMM DD YYYY')}
                    </p>

                </div>
                </div>
                <div className='col-lg-1 col-md-1 col-sm-1'>

                <div className='m'>

                    <a onClick={this.toggle} id='Popover1'>
                    <img src={calenderIcon} alt='' />
                    </a>
                    <Popover placement='bottom' isOpen={this.state.popoverOpen} target='Popover1'
                    toggle={this.toggle.bind(this)}>
                    <PopoverBody>
                        <div>
                        <DateRangePicker
                            onChange={this.handleRangeChange.bind(this, 'dateRangePicker')}
                            startDate={this.state.dateRangePicker.selection.startDate}
                            endDate={this.state.dateRangePicker.selection.endDate}
                            showSelectionPreview={true}
                            moveRangeOnFirstSelection={false}
                            className={'PreviewArea'}
                            months={2}
                            ranges={[this.state.dateRangePicker.selection]}
                            direction='horizontal'
                            maxDate={this.state.maxDateRange}
                        />

                        </div>
                    </PopoverBody>
                    </Popover>

                </div>

                </div>
                <div className="col-lg-1" style={{marginTop: "5px"}}>
                    <button className={`btn btn-primary search-btn  search-button`} style={{ padding: '7px 20px 7px 20px' }} onClick={this.generateExcell.bind(this)}>Export</button>
                </div>
            </div>
        </>
    );
  }
}

TemperatureReport.propTypes = {};
TemperatureReport.defaultProps = {};
const mapStateToProps = state => ({
  vehiclesPlateNumber: state.things.vehiclesPlateNumber,
  notifications: state.users.notifications.notifications,
  notificationsCount: state.users.notifications.notificationsCount,
  things: state.things.groupVehicles,
  hasMoreNotifications: state.users.hasMoreNotifications
});

const mapDispatchToProps = dispatch => ({

  actions: bindActionCreators(Users.creators, dispatch),
  thingsActions: bindActionCreators(Things.creators, dispatch)
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TemperatureReport));
